import S, { DataSignal } from 's-js';
import { IAjax, Request } from './ajax';
import { DataCacheCollection } from './DataCache';
import * as Promise from 'bluebird';

export type ModelDataClient<D> = (data : D) => Promise<{ data: D, timestamp: Date }>;

export function ModelDataClient<D>(ajax : IAjax, url : (data : D) => string) : ModelDataClient<D> {
    return function (data : D) {
        const req = ajax.Url<D>(url(data)).Get();
        return req.then(data => ({ data, timestamp: req.Date }));
    }
}

export type CachedModelLoader<T, D> = (data : D, refreshSeconds? : number) => { model : T, loading: () => boolean, task : Promise<T> }

export function CachedModelLoader<T, D>(cache : DataCacheCollection<T, D>, client : ModelDataClient<D>) : CachedModelLoader<T, D> {
    const active = {} as { [id : string] : DataSignal<boolean> | undefined },
        tasks = {} as { [id : string] : Promise<T> | undefined };

    return loader;

    function loader(data : D, refreshSeconds = 0) {
        var key = cache.dataKey(data),
            model = cache.update1(null, data),
            ts = cache.timestamp(key),
            loading : DataSignal<boolean>,
            task : Promise<T>;

        if (refreshSeconds === 0 || ts === undefined || (Date.now() - ts.getTime()) > refreshSeconds * 1000) {
            if (active[key]) {
                loading = active[key]!;
                task = tasks[key]!;
            } else {
                loading = active[key] = S.data(true);
                task = tasks[key] = client(data)
                    .then(resp => cache.update1(resp.timestamp, resp.data))
                    .finally(() => {
                        active[key] = undefined;
                        tasks[key] = undefined;
                        loading(false);
                    });
            }
        } else {
            loading = S.data(false);
            task = Promise.resolve(model);
        }

        return { model, loading, task };
    }
}


// WEBPACK FOOTER //
// ./lib/CachedModelLoader.ts